"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAttendingAccountingPaidFlagsApiResponseSchema = exports.setAttendingAccountingPaidFlagsApiPayloadSchema = void 0;
const zod_1 = require("zod");
exports.setAttendingAccountingPaidFlagsApiPayloadSchema = zod_1.z.object({
    amountAvailablePaid: zod_1.z.boolean().optional(),
    feePaid: zod_1.z.boolean().optional(),
});
exports.setAttendingAccountingPaidFlagsApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    amountAvailablePaid: zod_1.z.boolean(),
    feePaid: zod_1.z.boolean(),
});
